import _ from 'underscore';

import { Permission } from '../types/Permission';

export class PermissionsHasher {

  private capabilities: string[];

  constructor(capabilities: string[]) {
    this.capabilities = capabilities;
  }

  // A permissions hash is a string of characters, one per capability,
  // in the order they were passed in the constructor.
  // Each character is either A (allowed), D (denied), M (mixed), or - (unspecified).
  public hash(permissions: _.Dictionary<Permission>): string {
    return _.map(this.capabilities, (capability: string) => {
      switch (permissions[capability]) {
        case Permission.Allowed: return 'A';
        case Permission.Denied: return 'D';
        case Permission.Mixed: return 'M';
        default: return '-';
      }
    }).join('');
  }

}
